import { render, staticRenderFns } from "./2FA.vue?vue&type=template&id=52fb2826&scoped=true&lang=pug&"
import script from "./2FA.vue?vue&type=script&lang=js&"
export * from "./2FA.vue?vue&type=script&lang=js&"
import style0 from "./2FA.vue?vue&type=style&index=0&id=52fb2826&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb2826",
  null
  
)

export default component.exports